import Api from '@/services/Api';

export default {
	async editMyAccount() {
		return await Api.get('/api/account/edit');
	},
	async updateMyAccount(data) {
		return await Api.post('/api/account/update', data);
	}
};
